import eng from "./eng";
import ar from "./ar";
import fr from "./fr";
import es from "./es";
import sw from "./sw";

export const languages = { eng, ar, fr, es, sw };

export default languages;
